import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { AppRemixIcon } from '@/layout/AppComponents';
import * as authActions from '../../store/actions/authAction';
import * as globalActions from '../../store/actions/globalAction';
import colors from '../../constants/colors';

export default function Sidebar(props) {
  const {
    children,
    toggleable = true,
  } = props;
  const dispatch = useDispatch();
  const isSidebarOpened = useSelector(
    (state) => state.auth?.settings?.preferences?.sidebar?.isOpened
  );

  useEffect(() => {
    dispatch(globalActions.setIsSidebar(true));
    return () => dispatch(globalActions.setIsSidebar(false));
  }, []);

  /**
   * - Toggle sidebar settings and save config in DB
   */
  const toggleSidebarHandler = useCallback(async () => {
    try {
      await dispatch(
        authActions.setAuthSettingsLayout({
          key: 'isSidebarOpened',
          value: !isSidebarOpened,
        })
      );
    } catch (err) {
      // setError('Error al cargar el admin');
    }
  }, [isSidebarOpened]);

  return (
    <SidebarContainer>
      {toggleable && (
        <ToggleButton
          className={isSidebarOpened ? 'tb' : 'tb sidebar-expanded'}
        >
          <AppRemixIcon
            icon={isSidebarOpened ? 'arrow-left-s' : 'arrow-right-s'}
            filled
            onClick={() => toggleSidebarHandler()}
            size={20}
          />
        </ToggleButton>
      )}
      {isSidebarOpened !== undefined && (
        <Container
          className={`sidebar ${isSidebarOpened ? 'sidebar-expanded' : ''}`}
        >
          <div className="sb-rel">{children}</div>
        </Container>
      )}
    </SidebarContainer>
  );
}

const SidebarContainer = styled.nav`
  &:hover {
    .tb {
      opacity: 1;
    }
  }
`;
const Container = styled.nav`
  position: fixed;
  top: 40px;
  bottom: 0;
  left: 0;
  background-color: white;
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.1);
  padding: 6px;
  z-index: 100;
  transition: all ease 0.3s;
  width: 50px;
  overflow-y: auto;

  &.sidebar-expanded {
    width: 200px;
    .sidebar-heading {
      h1 {
        font-size: 14px;
      }
    }
  }
  ul {
    list-style: none;
    padding: 8px 0;
    margin: 0;
    li {
      .sidebar-element {
        display: flex;
        padding: 7px 10px;
        color: ${colors.gray900};
        cursor: pointer;
        transition: background-color ease 0.5s;
        align-items: baseline;
        i {
          margin-right: 6px;
        }
        .sidebar-icon {
          margin-right: 6px;
          margin-top: -3px;
          transition: margin ease 0.3s;
          font-size: 16px;
        }
        &:hover {
          text-decoration: none;
          background-color: $gray-200;
          .sidebar-icon {
            margin-right: 3px;
            margin-left: 3px;
          }
        }
        &.sub-element {
          padding-left: 20px;
        }
      }
      &.active {
        background-color: $gray-200;
        a {
          color: ${colors.gray900};
        }
      }
      &.divider {
        border: none;
        height: 1px;
        margin: 3px 0;
        flex-shrink: 0;
        background-color: rgba(0, 0, 0, 0.12);
      }
    }
  }

  @media (max-width: 767.98px) {
    .sidebar {
      top: 5rem;
    }
  }

  .sidebar-sticky {
    position: relative;
    top: 0;
    height: calc(100vh - 48px);
    padding-top: 0.5rem;
    overflow-x: hidden;
    overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
  }

  @supports ((position: -webkit-sticky) or (position: sticky)) {
    .sidebar-sticky {
      position: -webkit-sticky;
      position: sticky;
    }
  }

  .sidebar .nav-link {
    font-weight: 500;
    color: #333;
  }

  .sidebar .nav-link .feather {
    margin-right: 4px;
    color: #999;
  }

  .sidebar .nav-link.active {
    color: #007bff;
  }

  .sidebar .nav-link:hover .feather,
  .sidebar .nav-link.active .feather {
    color: inherit;
  }
`;

const ToggleButton = styled.div`
  position: fixed;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  top: 46px;
  left: 186px;
  cursor: pointer;
  background: white;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  width: 26px;
  height: 26px;
  transition: all ease 0.3s;
  color: ${colors.primary};
  &:hover {
    border: 1px solid white;
  }
  &.sidebar-expanded {
    left: 38px;
  }
`;
